import React from 'react'

const XMC = (props) => (
  <svg
    width={76}
    height={84}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.854 7.43h7.414v-.413c-2.941 0-4.212-1.594-3.872-4.89a1.745 1.745 0 0 0-1.73-1.92h-.848a.966.966 0 0 0-.964.966V7.43zm72.498 0h-7.415v-.413c2.942 0 4.212-1.594 3.873-4.89a1.745 1.745 0 0 1 1.73-1.92h.847c.533 0 .965.432.965.966V7.43z"
      fill="#F1F2F3"
    />
    <path
      d="M9.268 7.43v.206h.206V7.43h-.206zm-7.414 0h-.206v.206h.206V7.43zm7.414-.413h.206v-.206h-.206v.206zm-3.872-4.89.205.022-.205-.022zM4.957.782 5.11.644l-.153.138zM3.667.206V0v.206zm63.27 7.224h-.205v.206h.206V7.43zm7.415 0v.206h.206V7.43h-.206zm-7.415-.413v-.206h-.205v.206h.206zm3.873-4.89-.205.022.205-.022zm.438-1.345-.153-.138.153.138zM72.54.206V0v.206zM9.27 7.224H1.853v.412h7.414v-.412zm-.207-.207v.413h.412v-.413h-.412zm-3.871-4.91c-.172 1.67.058 2.957.75 3.829.696.879 1.822 1.287 3.327 1.287v-.412c-1.436 0-2.416-.388-3.005-1.131-.594-.749-.83-1.906-.662-3.531l-.41-.043zM4.804.918c.29.323.432.755.387 1.187l.41.043A1.95 1.95 0 0 0 5.11.644l-.307.275zM3.666.412c.434 0 .848.185 1.138.507L5.11.644A1.943 1.943 0 0 0 3.666 0v.412zm-.848 0h.848V0h-.848v.412zm-.759.761c0-.42.34-.76.76-.76V0C2.17 0 1.647.526 1.647 1.173h.411zm0 6.257V1.173h-.411V7.43h.411zm64.879.206h7.414v-.412h-7.415v.412zm-.206-.619v.413h.412v-.413h-.412zm3.873-4.868c.167 1.625-.068 2.782-.662 3.531-.59.743-1.57 1.131-3.005 1.131v.412c1.504 0 2.63-.408 3.327-1.287.692-.872.922-2.16.75-3.83l-.41.043zm.49-1.505a1.95 1.95 0 0 0-.49 1.505l.41-.043A1.539 1.539 0 0 1 71.4.92l-.306-.275zM72.54 0c-.55 0-1.075.234-1.444.644l.306.275A1.536 1.536 0 0 1 72.54.412V0zm.848 0h-.848v.412h.848V0zm1.171 1.173c0-.647-.524-1.173-1.17-1.173v.412a.76.76 0 0 1 .758.761h.412zm0 6.257V1.173h-.412V7.43h.412z"
      fill="#07070F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.707 70.585V74.3H.824V16.098h.204a.825.825 0 0 1-.822-.825V7.017h3.501v9.081-9.08h72.087v8.255a.825.825 0 0 1-.822.825h.204V74.3h-2.884v-3.715H3.707z"
      fill="#F1F2F3"
    />
    <path
      d="M3.707 74.3v.206h.206V74.3h-.206zm0-3.715v-.206h-.206v.206h.206zM.824 74.3H.618v.206h.206V74.3zm0-58.202v-.206H.618v.206h.206zm.204 0v.206-.412.206zm-.822-9.08V6.81H0v.206h.206zm3.501 0h.206V6.81h-.206v.206zm0 9.08h-.206v.206h.206v-.206zm0 0v.206h.206v-.206h-.206zm0-9.08V6.81h-.206v.206h.206zm72.087 0H76V6.81h-.206v.206zm-.822 9.08v-.206.412-.206zm.204 0h.206v-.206h-.206v.206zm0 58.202v.206h.206V74.3h-.206zm-2.884 0h-.206v.206h.206V74.3zm0-3.715h.206v-.206h-.206v.206zM3.913 74.3v-3.715h-.412V74.3h.412zm-3.09.206h2.884v-.412H.824v.412zM.619 16.098V74.3h.412V16.098H.618zm.41-.206H.824v.412h.204v-.412zm0 0a.619.619 0 0 1-.616-.62H0c0 .57.46 1.031 1.028 1.032v-.412zm-.616-.62V7.018H0v8.256h.412zM.206 7.224h3.501v-.412H.206v.412zM3.5 7.017v9.081h.412v-9.08H3.5zm.206 8.875v.412-.412zM3.5 7.017v9.081h.412v-9.08H3.5zm68.791-.206H3.707v.412h68.585v-.412zm3.502 0h-3.502v.412h3.502v-.412zM76 15.273V7.017h-.412v8.256H76zm-1.028 1.031A1.03 1.03 0 0 0 76 15.273h-.412a.619.619 0 0 1-.617.62l.001.411zm.204-.412h-.204v.412h.204v-.412zm.206 58.408V16.098h-.412V74.3h.412zm-3.09.206h2.884v-.412h-2.884v.412zm-.206-3.921V74.3h.412v-3.715h-.412zm-68.379.206h68.585v-.412H3.707v.412z"
      fill="#07070F"
    />
    <path
      d="M.412 76.776V71.53c0-.522.422-.945.943-.945h73.29c.52 0 .943.423.943.945v5.246H.412z"
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.412}
    />
    <rect
      x={2.986}
      y={63.671}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.78}
      y={50.049}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.986}
      y={39.523}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.986}
      y={28.791}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.986}
      y={18.059}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={4.105}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={19.758}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={35.411}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={51.064}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={66.717}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={11.725}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={27.378}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={43.032}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={58.685}
      y={73.047}
      width={5.384}
      height={1.267}
      rx={0.632}
      stroke="#07070F"
      strokeWidth={0.383}
    />
    <rect
      x={43.252}
      y={73.681}
      width={5.149}
      height={0.619}
      rx={0.309}
      fill="#07070F"
      fillOpacity={0.7}
    />
    <rect
      x={27.599}
      y={73.681}
      width={5.149}
      height={0.619}
      rx={0.309}
      fill="#07070F"
      fillOpacity={0.7}
    />
    <rect
      x={11.946}
      y={73.681}
      width={5.149}
      height={0.413}
      rx={0.206}
      fill="#07070F"
      fillOpacity={0.7}
    />
    <rect
      x={13.799}
      y={73.061}
      width={1.236}
      height={0.413}
      rx={0.206}
      fill="#07070F"
    />
    <rect
      x={29.452}
      y={73.061}
      width={1.236}
      height={0.413}
      rx={0.206}
      fill="#07070F"
    />
    <rect
      x={45.105}
      y={73.061}
      width={1.236}
      height={0.413}
      rx={0.206}
      fill="#07070F"
    />
    <rect
      x={60.758}
      y={73.061}
      width={1.236}
      height={0.413}
      rx={0.206}
      fill="#07070F"
    />
    <rect
      x={58.905}
      y={73.681}
      width={5.149}
      height={0.619}
      rx={0.309}
      fill="#07070F"
      fillOpacity={0.7}
    />
    <rect
      x={30.379}
      y={31.887}
      width={16.065}
      height={7.017}
      rx={0.766}
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={31.203}
      y={32.712}
      width={14.417}
      height={5.366}
      rx={0.766}
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={30.688}
      y={54.899}
      width={14.829}
      height={6.398}
      rx={0.766}
      stroke="#07070F"
      strokeWidth={0.412}
    />
    <rect
      x={29.041}
      y={53.661}
      width={17.919}
      height={8.668}
      rx={0.766}
      stroke="#07070F"
      strokeWidth={0.412}
    />
    <path
      d="M41.604 55.725H44.9v3.302h-3.296v-3.302z"
      fill="#07070F"
      fillOpacity={0.7}
    />
    <path
      d="M17.816 6.914v-.103h-.103v.103h.103zm2.06 0h.102v-.103h-.103v.103zm0 1.857v.103h.102v-.103h-.103zm-2.06 0h-.103v.103h.103v-.103zm7.62-1.857v-.103h-.103v.103h.103zm24.2 3.509v.103-.103zm.722-3.509h.103v-.103h-.103v.103zm-32.542.103h2.06v-.206h-2.06v.206zm1.956-.103v1.857h.206V6.914h-.206zm.103 1.755h-2.06v.205h2.06V8.67zm-1.956.102V6.914h-.206v1.857h.206zm7.414-1.857V9.7h.206V6.914h-.206zm0 2.786c0 .456.369.826.824.826v-.206a.619.619 0 0 1-.618-.62h-.206zm.824.826h23.48v-.206h-23.48v.206zm23.48 0c.455 0 .824-.37.824-.826h-.206c0 .343-.277.62-.618.62v.206zm.824-.826V6.914h-.206V9.7h.206zm-.103-2.889H25.436v.206h24.922v-.206z"
      fill="#07070F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.512 35.292h.618v2.683h-.618v-2.683zm2.06 20.226h-2.266v1.239h2.266v-1.239zm-.412 1.858h-1.854v1.445h1.854v-1.445zm-.206-22.084h-.618v2.683h.618v-2.683zm.824 20.226h.412v1.239h-.412v-1.239zm4.119 0h-.412v1.239h.412v-1.239zm-3.501 0h.412v1.239h-.412v-1.239zm4.119 0h-.412v1.239h.412v-1.239zm-3.502 0h.413v1.239h-.413v-1.239zm1.03 0h-.412v1.239h.412v-1.239zm.618 0v1.239h-.412v-1.239h.412zm.618 0h-.412v1.239h.412v-1.239zm-3.501 1.445h3.501v.413h-3.501v-.413zm7.414 0h-2.471v.413h2.471v-.413zm-7.414 1.032h5.56v.62h-5.56v-.62zm3.707.826h-3.707v.412h3.707v-.412zm.824 0h1.648v.412h-1.648v-.412zm-4.943 1.032v-.413h-.412v.413h.412zm3.707-.413v.413h-.412v-.413h.412zm-3.09 0h-.411v.413h.412v-.413zm3.296 0h.412v.413h-.412v-.413zm-2.677 0h-.412v.413h.412v-.413zm.206 0h.411v.413h-.411v-.413zm1.03 0h-.413v.413h.412v-.413zm.205 0h.412v.413h-.412v-.413zm2.266.413v-.413h-.412v.413h.412zm3.295-.413h.412v.413h-.412v-.413zm-2.677 0h-.412v.413h.412v-.413zm3.295 0h.412v.413h-.412v-.413zm-2.677.413v-.413h-.412v.413h.412zm.618-.413v.413h-.412v-.413h.412zm.618.413v-.413h-.412v.413h.412zm.617-.413v.413h-.412v-.413h.412zm2.06 1.238v-.413h-2.472v.413h2.472zM33.16 35.292h.618v2.683h-.618v-2.683zm1.442 0h-.618v2.683h.618v-2.683zm.206 0h.617v2.683h-.617v-2.683zm1.441 0h-.618v2.683h.618v-2.683zm.206 0h.618v2.683h-.618v-2.683zm1.442 0h-.618v2.683h.618v-2.683zm.206 0h.618v2.683h-.618v-2.683zm1.442 0h-.618v2.683h.618v-2.683zm.206 0h.618v2.683h-.618v-2.683zm1.441 0h-.617v2.683h.617v-2.683zm.206 0h.618v2.683h-.618v-2.683zm1.442 0h-.618v2.683h.618v-2.683zm.206 0h.618v2.683h-.618v-2.683zm1.442 0h-.618v2.683h.618v-2.683zm.206 0h.618v2.683h-.618v-2.683zM32.542 59.44h-1.236v1.238h1.236V59.44z"
      fill="#07070F"
      fillOpacity={0.7}
    />
    <path
      d="M10.607 79.07v4.827h27.008l1.536-2.89h26.448V76.88h-53.55v1.634l-1.442.556z"
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.986}
      y={63.671}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.78}
      y={50.049}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.986}
      y={39.523}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.986}
      y={28.791}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <rect
      x={2.986}
      y={18.059}
      width={70.233}
      height={2.27}
      rx={0.766}
      fill="#F1F2F3"
      stroke="#07070F"
      strokeWidth={0.206}
    />
    <path
      d="M38.72 60.265h1.442v.413h-1.441v-.413z"
      fill="#07070F"
      fillOpacity={0.7}
    />
    <path
      d="m31.924 34.88.53-.862-.48-.79h.366l.31.53.306-.53h.362l-.482.802.53.85h-.378l-.344-.572-.344.572h-.376z"
      fill="#07070F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m33.69 34.018-.53.862h.375l.345-.572.344.572h.377l-.53-.85.483-.802h-.363l-.305.53-.31-.53h-.367l.48.79zm2.471 0-.53.862h.376l.344-.572.344.572h.378l-.53-.85.482-.802h-.362l-.305.53-.311-.53h-.366l.48.79z"
      fill="#07070F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m37.397 34.018-.53.862h.375l.345-.572.344.572h.378l-.53-.85.482-.802h-.363l-.304.53-.311-.53h-.366l.48.79zm1.442 0-.53.862h.375l.345-.572.344.572h.377l-.53-.85.483-.802h-.363l-.305.53-.31-.53h-.367l.48.79z"
      fill="#07070F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m39.545 34.88.53-.862-.48-.79h.365l.311.53.305-.53h.363l-.483.802.53.85h-.377l-.344-.572-.345.572h-.375zm1.441 0 .53-.862-.48-.79h.366l.311.53.305-.53h.362l-.482.802.53.85h-.377l-.344-.572-.345.572h-.376zm2.796-.862-.53.862h.375l.345-.572.344.572h.378l-.53-.85.482-.802h-.363l-.304.53-.311-.53h-.366l.48.79z"
      fill="#07070F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m2.53 78.82-.47-2.044h10.298v2.27a.412.412 0 0 1-.412.413h-2.06a.412.412 0 0 1-.412-.412v-.62a.412.412 0 0 0-.412-.412H7.415a.412.412 0 0 0-.412.412v.62a.412.412 0 0 1-.412.413H3.333a.824.824 0 0 1-.803-.64zm70.94 0 .47-2.044H63.642v2.27c0 .229.185.413.412.413h2.06a.412.412 0 0 0 .412-.412v-.62c0-.228.184-.412.412-.412h1.647c.228 0 .412.184.412.412v.62c0 .228.185.413.412.413h3.258a.824.824 0 0 0 .803-.64z"
      fill="#F1F2F3"
    />
    <path
      d="M2.06 76.776v-.206H1.8l.059.253.2-.047zm.47 2.044-.2.046.2-.046zm9.828-2.044h.206v-.206h-.206v.206zM3.333 79.46v-.206.206zm70.607-2.684.201.047.058-.252h-.259v.205zm-.47 2.044.2.046-.2-.046zm-9.828-2.044v-.206h-.206v.206h.206zm9.025 2.684v-.206.206zM1.86 76.823l.47 2.043.402-.093-.47-2.043-.402.093zm10.499-.252H2.06v.411h10.298v-.412zm.206 2.476v-2.27h-.412v2.27h.412zm-.618.618a.618.618 0 0 0 .618-.618h-.412a.206.206 0 0 1-.206.207v.411zm-2.06 0h2.06v-.412h-2.06v.412zm-.618-.618c0 .341.276.618.618.618v-.412a.206.206 0 0 1-.206-.206h-.412zm0-.62v.62h.412v-.62h-.412zm-.206-.206c.114 0 .206.092.206.206h.412a.618.618 0 0 0-.618-.618v.412zm-1.647 0h1.647v-.412H7.415v.412zm-.206.206c0-.114.092-.206.206-.206v-.412a.618.618 0 0 0-.618.618h.412zm0 .62v-.62h-.412v.62h.412zm-.618.618a.618.618 0 0 0 .618-.618h-.412a.206.206 0 0 1-.206.207v.411zm-3.258 0H6.59v-.412H3.333v.412zm-1.004-.8c.108.469.524.8 1.004.8v-.412a.618.618 0 0 1-.602-.48l-.402.093zm71.41-2.135-.47 2.043.402.093.47-2.043-.401-.093zm-10.097.252H73.94v-.412H63.642v.412zm.206 2.065v-2.27h-.412v2.27h.412zm.206.207a.206.206 0 0 1-.206-.207h-.412c0 .341.276.618.618.618v-.412zm2.06 0h-2.06v.411h2.06v-.412zm.206-.207a.206.206 0 0 1-.206.207v.411a.618.618 0 0 0 .618-.618h-.412zm0-.62v.62h.412v-.62h-.412zm.618-.618a.618.618 0 0 0-.618.618h.412c0-.114.092-.206.206-.206v-.412zm1.647 0h-1.647v.412h1.647v-.412zm.618.618a.618.618 0 0 0-.618-.618v.412c.114 0 .206.092.206.206h.412zm0 .62v-.62h-.412v.62h.412zm.206.207a.206.206 0 0 1-.206-.207h-.412c0 .341.277.618.618.618v-.412zm3.258 0H69.41v.411h3.258v-.412zm.602-.48a.618.618 0 0 1-.602.48v.411c.48 0 .896-.331 1.004-.8l-.402-.092z"
      fill="#07070F"
    />
    <path
      d="M13.181 76.776h10.505v5.16a.62.62 0 0 1-.618.62h-9.269a.619.619 0 0 1-.618-.62v-5.16z"
      stroke="#07070F"
      strokeWidth={0.412}
    />
    <path d="M14.211 76.57h.412v6.192h-.412V76.57z" fill="#07070F" />
    <path
      d="M25.54 76.776h12.357v5.16a.62.62 0 0 1-.618.62H26.157a.619.619 0 0 1-.618-.62v-5.16z"
      stroke="#07070F"
      strokeWidth={0.412}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.631 76.57h-.412v6.192h.412V76.57zm1.03 0h-.412v6.192h.412V76.57z"
      fill="#07070F"
    />
    <path
      d="M39.957 76.776H56.64v3.303a.413.413 0 0 1-.412.413h-15.86a.413.413 0 0 1-.411-.413v-3.303z"
      stroke="#07070F"
      strokeWidth={0.412}
    />
  </svg>
)

export default XMC
